function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var pcsPageForm = new ( /*#__PURE__*/function () {
  function PcsPageForm() {
    var _this = this;
    _classCallCheck(this, PcsPageForm);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(PcsPageForm, [{
    key: "init",
    value: function init() {
      $(document).on('click', '[data-action="add-note"]', this.onShowAddNote.bind(this));
      $(document).on('click', '[data-action="add-reminder"]', this.onShowAddReminder.bind(this));
      $(document).on('submit', '#form-show-item', this.onSubmitShowItem.bind(this));
      vent.publish('PCS:REFRESH_UI');
    }
  }, {
    key: "getFormElements",
    value: function getFormElements($elt) {
      var $form = $elt.closest('.pcs-page-form');
      var $fields = $form.find('.pcs-form-values__fields');
      return {
        $form: $form,
        $fields: $fields
      };
    }
  }, {
    key: "onShowAddNote",
    value: function onShowAddNote(e) {
      var formElts = this.getFormElements($(e.target));
      formElts.$form.attr('data-show', formElts.$form.attr('data-show') !== 'note' ? 'note' : 'values');
      vent.publish('PCS:REFRESH_UI');
    }
  }, {
    key: "onShowAddReminder",
    value: function onShowAddReminder(e) {
      var formElts = this.getFormElements($(e.target));
      formElts.$form.attr('data-show', formElts.$form.attr('data-show') !== 'reminder' ? 'reminder' : 'values');
      vent.publish('PCS:REFRESH_UI');
    }
  }, {
    key: "onSubmitShowItem",
    value: function onSubmitShowItem(e) {
      e.preventDefault();
      vent.publish('PCS:SUBMIT_FORM', {
        form: $(e.target)
      });
    }
  }]);
  return PcsPageForm;
}())();